import React from 'react';
import {
  Button, Card, DatePicker, Input, Spin,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Text from '../../shared/components/basic/Text';
import { setRangoFechas, setSearchText } from '../../../state/actions/creators/newCo.reposiciones.actioncreator';
import { Box, ShowIf } from '../../shared/components';
import Flex from '../../shared/components/basic/Flex';

export default function SearchTextComponent({ text }) {
  const dispatch = useDispatch();
  const rangoFechas = useSelector(({ newCoReposiciones }) => newCoReposiciones.filters.rangoFechas);
  return (
    <Card
      className="filterCard"
      bordered={false}
      style={{ width: '100%' }}
    >
      <Flex marginTop="16px" alignItems="baseline">
        <Text style={{ whiteSpace: 'nowrap' }}>Rango Uds. Vendidas: </Text>
        <Box mx="8px">
          <DatePicker
            value={rangoFechas?.date_ini}
            size="large"
            format="DD-MM-YYYY"
            onChange={valor => dispatch(setRangoFechas({ date_ini: valor }))}
            disabledDate={current => moment().add(-1, 'days') <= current}
          />
        </Box>
        <Box>-</Box>
        <Box mx="8px">
          <DatePicker
            value={rangoFechas?.date_fin}
            size="large"
            format="DD-MM-YYYY"
            onChange={valor => dispatch(setRangoFechas({ date_fin: valor }))}
            disabled
          />
        </Box>
        <Box ml="8px" width="80%">
          <Input.Search placeholder="Buscar por nombre" size="large" value={text} onChange={event => dispatch(setSearchText(event?.target?.value))} />
        </Box>
      </Flex>
    </Card>
  );
}
